import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiDisclosureButton',
  setup(__props) {

const isOpen = inject('isOpen') as Ref<boolean>;
const toggle = inject('toggle') as () => void;

return { __sfc: true,isOpen, toggle }
}

})